<template>
  <el-dialog width="520px"
             v-dialog-drag
             :title="modifyDomainType == 'server' ? '配置小程序服务器域名' : '配置小程序业务域名'"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="modifyDomainVisible">
     <div class="from_box">

       <el-form size="small"   ref="currencyForm"   label-position="left"   label-width="140px"  :model="currencyForm"  :rules="currencyFormRules">
         <template v-if="modifyDomainType == 'server'">
           <el-form-item label="" prop="action">
             <el-radio-group v-model="currencyForm.action">
               <el-radio label="add">添加</el-radio>
               <el-radio label="set">覆盖</el-radio>
             </el-radio-group>
           </el-form-item>
           <el-form-item label="requestdomain" prop="requestdomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.requestdomain"></el-input>
           </el-form-item>
           <el-form-item label="wsrequestdomain" prop="wsrequestdomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.wsrequestdomain"></el-input>
           </el-form-item>
           <el-form-item label="uploaddomain" prop="uploaddomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.uploaddomain"></el-input>
           </el-form-item>
           <el-form-item label="downloaddomain" prop="downloaddomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.downloaddomain"></el-input>
           </el-form-item>
           <el-form-item label="udpdomain" prop="udpdomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.udpdomain"></el-input>
           </el-form-item>
           <el-form-item label="tcpdomain" prop="tcpdomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.tcpdomain"></el-input>
           </el-form-item>
         </template>

         <template v-else>
           <el-form-item label="" prop="action">
             <el-radio-group v-model="currencyForm.action">
               <el-radio label="add">添加</el-radio>
               <el-radio label="set">覆盖</el-radio>
             </el-radio-group>
           </el-form-item>
           <el-form-item label="webviewdomain" prop="webviewdomain">
             <el-input placeholder="请填写" type="textarea"  v-model="currencyForm.webviewdomain"></el-input>
           </el-form-item>

         </template>


       </el-form>


     </div>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {modifyServerDomain , modifyJumpDomain} from "@/api";

export default {
  name: "wechat_commitTrial",
  props: {
    modifyDomainVisible: {
      type: Boolean,
      default: false,
    },
    weChatAppId: {
      type: String,
      default: '',
    },
    modifyDomainType: {
      type: String,
      default: '',
    },

  },
  data() {
    return {
      loading: false,
      btnDisabled: false,

      currencyForm:{
        action:'add',
        requestdomain:'',
        wsrequestdomain:'',
        uploaddomain:'',
        downloaddomain:'',
        udpdomain:'',
        tcpdomain:'',


        webviewdomain:''
      },
      currencyFormRules:{
        // wxapp_name:[{ required: true, message: '请输入小程序名称', trigger: 'blur'}],
      },
    }
  },
  created() {


  },
  mounted() {
  },
  methods: {

    handleClickCancel() {
      this.$emit('update:modifyDomainVisible', false)
    },

    handleClickConfirm() {
      this.btnDisabled = true
      if(this.modifyDomainType == 'server'){
        modifyServerDomain({
          action:this.currencyForm.action,
          requestdomain:this.currencyForm.requestdomain ? this.currencyForm.requestdomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
          wsrequestdomain:this.currencyForm.wsrequestdomain ? this.currencyForm.wsrequestdomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
          uploaddomain:this.currencyForm.uploaddomain ? this.currencyForm.uploaddomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
          downloaddomain:this.currencyForm.downloaddomain ? this.currencyForm.downloaddomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
          udpdomain:this.currencyForm.udpdomain ? this.currencyForm.udpdomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
          tcpdomain:this.currencyForm.tcpdomain ? this.currencyForm.tcpdomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
        },{
          headers:{
            appid: this.weChatAppId,
          }
        }).then(res => {
          this.$message.success('操作成功')
          this.$emit('success')
          this.$emit('update:modifyDomainVisible', false)
        }).catch(() => {
          this.btnDisabled = false
        })
      }else{
        modifyJumpDomain({
          action:this.currencyForm.action,
          webviewdomain:this.currencyForm.webviewdomain ? this.currencyForm.webviewdomain.split(';').filter(item => item != null && item !== '' && !Number.isNaN(item)) : [],
        },{
          headers:{
            appid: this.weChatAppId,
          }
        }).then(res => {
          this.$message.success('操作成功')
          this.$emit('success')
          this.$emit('update:modifyDomainVisible', false)
        }).catch(() => {
          this.btnDisabled = false
        })
      }

    },
  }
}
</script>
<style lang="scss" scoped>
  .from_box{
    padding: 30px 0 15px;
  }
</style>
